import React, { useMemo } from "react"

import { OneVerifyPermission } from "@common-shared/config/rolesPermissions.config"

import { PAYER_MAPPINGS_CONFIG } from "../../../config/payerMappings.config"
import { RuntimeHelper } from "../../../helpers/runtime.helper"
import { useHasPermissions } from "../../../hooks/hasPermissions.hook"
import { useAppDispatch } from "../../../store/appDispatch.hook"
import { useAppSelector } from "../../../store/selectors/app.selector"
import { payerMappingsSelector } from "../../../store/selectors/payerMappings.selector"
import { runtimeSelector } from "../../../store/selectors/runtime.selector"
import { selectedPracticeRoleSelector } from "../../../store/selectors/selectedPracticeRole.selector"
import { payerMappingsExportList } from "../../../store/thunks/payerMappings.thunks"
import { CsvActionsDropdownComponent } from "../../general/csvUploads/csvActionsDropdown.component"

export const PayerMappingsCsvDropdownComponent: React.FunctionComponent<
    IPayerMappingsCsvDropdownComponentProps
> = props => {
    const dispatch = useAppDispatch()

    const selectedPracticeRole = useAppSelector(selectedPracticeRoleSelector)
    const payerMappings = useAppSelector(payerMappingsSelector)
    const runtimeState = useAppSelector(runtimeSelector)

    const canManagePracticeConfigurations = useHasPermissions(
        OneVerifyPermission.managePracticeConfigurations,
        undefined,
        false,
    )

    const isExportLoading = useMemo<boolean>(() => {
        return RuntimeHelper.isPayerMappingsExportListLoading()
    }, [runtimeState.isLoading])

    const handleDownloadMappingsAsCsv = () => {
        if (!selectedPracticeRole) {
            return
        }

        dispatch(
            payerMappingsExportList({
                practice: selectedPracticeRole.practice,
                payload: undefined,
            }),
        )
    }

    return (
        <CsvActionsDropdownComponent
            templateUrl={PAYER_MAPPINGS_CONFIG.csvTemplateUrl}
            canUpload={canManagePracticeConfigurations ?? false}
            uploadLabel="Add payer mappings"
            onUpload={props.onOpenBulkUpload}
            downloadLabel="Download mappings"
            onDownload={handleDownloadMappingsAsCsv}
            isDownloadDisabled={!selectedPracticeRole}
            isExportLoading={isExportLoading}
            exportProgress={payerMappings.exportProgress}
        />
    )
}

interface IPayerMappingsCsvDropdownComponentProps {
    onOpenBulkUpload: () => void
}
